// helpers
import { logout as logoutApi } from '../../helpers';
import { APICore, setAuthorization } from '../../helpers/api/apiCore';

export default function useLogout() {
    const api = new APICore();
        api.setLoggedInUser(null);
        setAuthorization(null);
        localStorage.clear();
        sessionStorage.clear();
    
    return true;
}
